import { render } from "./DashboardPrefeitura.vue?vue&type=template&id=0561b62a"
import script from "./DashboardPrefeitura.vue?vue&type=script&lang=js"
export * from "./DashboardPrefeitura.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rafael\\projetos\\laravel\\enjoy_inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__